import React from "react";
import PropTypes from "prop-types";

function ContextChoice({ contexts, onSelect, disabled, error }) {
  return (
    <div className="quiz-text">
      {error && (
        <div role="alert" className="alert alert-danger">
          {error}
        </div>
      )}
      <h2><strong>Wybierz konto</strong></h2>
      <div className="row">
        {contexts.map(context => (
          <div className="col-md-4 mb-2" key={context.contextKey}>
            <button
              type="button"
              className="btn manage-button manage-red-button btn-block"
              disabled={disabled}
              onClick={() => onSelect(context)}
            >
              {context.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

ContextChoice.propTypes = {
  contexts: PropTypes.arrayOf(PropTypes.shape({
    contextKey: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

ContextChoice.defaultProps = {
  disabled: false,
  error: "",
};

export default ContextChoice;
